module.exports = __webpack_public_path__ + "static/media/web logos_NLT.4dcb2866.jpg";